import { Fieldset, PasswordInput, Textarea, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';

import { CreatePracticalInformationFieldDtoFieldTypeEnum } from 'src/Services/API/generated';

import { EventRecurrenceCreationForm } from '../../../Event/EventForm/EventRecurrenceCreationForm';

import styles from './RenderField.module.scss';
import { Props } from './RenderField.types';

const RenderField = ({ field, index, form, t }: Props) => {
  switch (field.fieldType) {
    case CreatePracticalInformationFieldDtoFieldTypeEnum.Text:
      return field.multiline ? (
        <Textarea
          {...form.getInputProps(`fields.${index}.value`)}
          label={t(`practicalInformation.placeholders.${field.key}`)}
          key={[index, field.fieldType].join(',')}
          placeholder={t(`practicalInformation.placeholders.${field.key}`)}
          minRows={4}
          autosize
        />
      ) : (
        <TextInput
          {...form.getInputProps(`fields.${index}.value`)}
          label={t(`practicalInformation.placeholders.${field.key}`)}
          key={[index, field.fieldType].join(',')}
          placeholder={t(`practicalInformation.placeholders.${field.key}`)}
        />
      );
    case CreatePracticalInformationFieldDtoFieldTypeEnum.Password:
      return (
        <PasswordInput
          {...form.getInputProps(`fields.${index}.value`)}
          key={[index, field.fieldType].join(',')}
          label={t(`practicalInformation.placeholders.${field.key}`)}
          placeholder={t(`practicalInformation.placeholders.${field.key}`)}
        />
      );
    case CreatePracticalInformationFieldDtoFieldTypeEnum.Date:
      return (
        <DatePickerInput
          {...form.getInputProps(`fields.${index}.value`)}
          key={[index, field.fieldType].join(',')}
          label={t(`practicalInformation.placeholders.${field.key}`)}
          placeholder={t(`practicalInformation.placeholders.${field.key}`)}
          valueFormat="DD/MM/YYYY"
        />
      );
    case CreatePracticalInformationFieldDtoFieldTypeEnum.Schedule:
      return (
        <Fieldset
          legend={t(`practicalInformation.placeholders.${field.key}`)}
          className={styles.recurrenceInput}
        >
          <DatePickerInput
            {...form.getInputProps(`fields.${index}.value.dtstart`)}
            key={[index, field.fieldType].join(',')}
            label={t(`practicalInformation.placeholders.startDate`, 'Date de début')}
            placeholder={t(`practicalInformation.placeholders.fromDate`, 'À partir de')}
            valueFormat="DD/MM/YYYY"
            className={styles.recurrenceStartInput}
          />
          <EventRecurrenceCreationForm
            // TODO : fix this type problem
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            form={form}
            paths={{
              frequency: `fields.${index}.value.frequency`,
              interval: `fields.${index}.value.interval`,
              customFrequency: `fields.${index}.value.customFrequency`,
              monthDayNumberOrAdvanced: `fields.${index}.value.monthDayNumberOrAdvanced`,
              weekDays: `fields.${index}.value.byWeekDays`,
              monthDayNumber: `fields.${index}.value.monthDayNumber`,
              month: `fields.${index}.value.byMonth`,
              advancedMonthDay: `fields.${index}.value.byWeekDay`,
              advancedMonthWeek: `fields.${index}.value.byMonthDay`,
              monthDaySelected: `fields.${index}.value.monthDaySelected`,
              until: `fields.${index}.value.until`,
            }}
          />
        </Fieldset>
      );
    case CreatePracticalInformationFieldDtoFieldTypeEnum.List:
      return (
        <div key={[index, field.fieldType].join(',')} className={styles.listField}>
          <TextInput
            {...form.getInputProps(`fields.${index}.value`)}
            label={t(`practicalInformation.placeholders.${field.key}`)}
            placeholder={t(`practicalInformation.placeholders.${field.key}`)}
            description={t(
              'practicalInformation.listDescription',
              'Saisissez plusieurs éléments séparés par des virgules'
            )}
          />
        </div>
      );
    default:
      return (
        <TextInput
          {...form.getInputProps(`fields.${index}.value`)}
          key={[index, field.fieldType].join(',')}
          label={t(`practicalInformation.placeholders.${field.key}`)}
          placeholder={t(`practicalInformation.placeholders.${field.key}`)}
        />
      );
  }
};

export default RenderField;
